// src/pages/dashboard/Reports.jsx
import React from "react";
import PageShell from "./PageShell";
export default function Reports() {
  return <PageShell title="Reports" />;
}
